import styled from 'styled-components';
import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  align-items: center;
  margin-left: 0.3rem;
`;

export const Title = styled(TextLayoutComponent.Bold)`
  color: ${(props) => props.theme.color.textSecondary};
`;

export const DataList = styled.div`
`;

export const Data = styled.div`
  display: flex;
  padding: 10px 0;
`;

export const TesterName = styled.div`
  display: flex;
  width: 15%;
  font-weight: 500;
`;

export const AnswerOtherResponse = styled.div`
  display: flex;
  flex: 1;
`;
